package pwgs.ui.scenes.ensureloggedin


class EnsureLoggedInControllerFe(props: EnsureLoggedInSceneProps, scene: MEnsureLoggedInScene) : AEnsureLoggedInControllerFe(props, scene) {

    override fun createInitialModel() : EnsureLoggedInSceneModel {
        return EnsureLoggedInSceneModel(true, false)
    }

    override fun init() {
        call_load()
    }


}

